import { render, staticRenderFns } from "./ProjectAuditLogsStandortlisteTable.vue?vue&type=template&id=3b6eecd3&scoped=true&"
import script from "./ProjectAuditLogsStandortlisteTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectAuditLogsStandortlisteTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAuditLogsStandortlisteTable.vue?vue&type=style&index=0&id=3b6eecd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6eecd3",
  null
  
)

export default component.exports